import { render, staticRenderFns } from "./ContentExpand.vue?vue&type=template&id=f917f0da&scoped=true&"
import script from "./ContentExpand.vue?vue&type=script&lang=js&"
export * from "./ContentExpand.vue?vue&type=script&lang=js&"
import style0 from "./ContentExpand.vue?vue&type=style&index=0&id=f917f0da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f917f0da",
  null
  
)

export default component.exports